import Image from 'next/image';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import { VideoSectionDTO } from '@lib/strapi/dtos/components/sections/videoSection.dto';
import { SectionHeading } from '../shared-ui';

/**
 * The clinic video (item 15 — fast-follow content). Local file with a poster;
 * never autoplayed. If an externalUrl is ever used it must be a
 * youtube-nocookie embed, per the CSP.
 */
const VideoSectionImplementation = ({ section }: ComponentProps<VideoSectionDTO>) => {
  const src = (section as { video?: { url?: string } } | undefined)?.video?.url;
  const poster = (section as { poster?: { url?: string } } | undefined)?.poster?.url;
  if (!src) return null;

  return (
    <section className="my-14 md:my-20">
      <SectionHeading heading={section?.heading} intro={section?.intro} />
      <video controls preload="none" poster={poster} className="w-full rounded-2xl border border-rule">
        <source src={src} />
      </video>
    </section>
  );
};

export default VideoSectionImplementation;
